// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

mat-dialog-actions {
  justify-content: flex-end;
}

.widgets {
  flex: 1;
  overflow: auto;
}
.widgets table {
  width: 100%;
}

.mat-row {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.mat-active {
  background-color: #0078d7;
  font-weight: bold;
  color: white;
  right: 0;
}

.mat-noactive {
  background-color: white;
  font-weight: bold;
  color: #0078d7;
  right: 0;
}

::ng-deep .mat-checkbox-checked .mat-checkbox-background {
  background-color: #01c4f5 !important;
}

::ng-deep .mat-checkbox-indeterminate .mat-checkbox-background {
  background-color: #01c4f5 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/roles/roles-form/roles-form.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,OAAA;EACA,cAAA;AACJ;AAAI;EACI,WAAA;AAER;;AAEA;EACI,eAAA;EACA,yBAAA;UAAA,iBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,QAAA;AACJ;;AAEE;EACE,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,QAAA;AACJ;;AAEE;EACE,oCAAA;AACJ;;AAEE;EACE,oCAAA;AACJ","sourcesContent":["mat-dialog-content {\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\nmat-dialog-actions {\r\n    justify-content: flex-end;\r\n}\r\n\r\n.widgets {\r\n    flex: 1;\r\n    overflow: auto;\r\n    table {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.mat-row {\r\n    cursor: pointer;\r\n    user-select: none;\r\n}\r\n\r\n.mat-active{\r\n    background-color: #0078d7;\r\n    font-weight:bold;\r\n    color:white; \r\n    right:0;\r\n  }\r\n  \r\n  .mat-noactive{\r\n    background-color: #ffff;\r\n    font-weight:bold;\r\n    color:#0078d7; \r\n    right:0;\r\n  }\r\n\r\n  ::ng-deep .mat-checkbox-checked  .mat-checkbox-background {\r\n    background-color: #01c4f5 !important;\r\n  }\r\n  \r\n  ::ng-deep .mat-checkbox-indeterminate .mat-checkbox-background {\r\n    background-color: #01c4f5 !important;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
